import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import ChevronDownIcon from '@atlaskit/icon/glyph/chevron-down';
import { Inline, xcss } from '@atlaskit/primitives';
import Pressable from '@atlaskit/primitives/pressable';
import { useStatsig } from '@atlassian/mpac-feature-flags';
import React, { forwardRef } from 'react';
import { mergeRefs } from '../../../mergeRefs';
import { TEST_IDS } from '../../../TestIds';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
const buttonStyles = xcss({
  cursor: 'pointer',
  paddingInlineStart: 'space.150',
  paddingInlineEnd: 'space.050',
  paddingBlock: 'space.050',
  borderRadius: 'radius.small',
  textAlign: 'center',
  display: 'flex',
  alignItems: 'center',
  color: 'color.text',
  backgroundColor: 'color.background.neutral',
  fontSize: '0.875rem',
  fontWeight: '400',
  ':hover': {
    backgroundColor: 'color.background.neutral.hovered'
  },
  ':active': {
    backgroundColor: 'color.background.neutral.pressed'
  }
});
const selectedStyles = xcss({
  color: 'color.text.selected',
  backgroundColor: 'color.background.selected',
  ':hover': {
    backgroundColor: 'color.background.selected.hovered'
  },
  ':active': {
    backgroundColor: 'color.background.selected.pressed'
  }
});
const buttonStyleWC = xcss({
  borderRadius: "var(--ds-space-250, 20px)",
  lineHeight: '0.875rem'
});
const flipIconStyles = xcss({
  transform: 'rotate(180deg)'
});
const SelectTriggerInternal = (_ref, ref) => {
  let {
    triggerProps,
    filterLabel,
    isSelected,
    isExpanded,
    numberOfSelections,
    firstSelectedOptionLabel,
    onClick
  } = _ref;
  const {
    enableMpacWebCoherence
  } = useStatsig();
  const isMpacWebCoherenceEnabled = enableMpacWebCoherence();
  return /*#__PURE__*/_jsxs(Pressable, _objectSpread(_objectSpread({}, triggerProps), {}, {
    ref: mergeRefs(ref, triggerProps.ref),
    onClick: onClick,
    "data-testId": TEST_IDS.FACET_DROPDOWN_TRIGGERS,
    xcss: [buttonStyles, isSelected && selectedStyles, isMpacWebCoherenceEnabled && buttonStyleWC],
    children: [/*#__PURE__*/_jsxs("span", {
      children: [firstSelectedOptionLabel || filterLabel, numberOfSelections > 1 && /*#__PURE__*/_jsxs(_Fragment, {
        children: [', ', /*#__PURE__*/_jsx("strong", {
          children: "+".concat(numberOfSelections - 1)
        })]
      })]
    }), /*#__PURE__*/_jsx(Inline, {
      xcss: isExpanded ? flipIconStyles : undefined,
      as: "span",
      children: /*#__PURE__*/_jsx(ChevronDownIcon, {
        label: ""
      })
    })]
  }));
};
export const SelectTrigger = /*#__PURE__*/forwardRef(SelectTriggerInternal);